export const DASHBOARD_LINK = "/~/dashboard";
export const OPERATIONS_LINK = "/~/operations";
export const VIRTUAL_CARDS_LINK = "/~/virtual-cards";
export const ADD_VIRTUAL_CARDS_LINK = "/~/virtual-cards/new";
export const HISTORY_LINK = "/~/transaction-history";
export const LOGIN = "/login";
export const REGISTER = "/register";
export const ONBOARDING = "/on-boarding";
export const SAVED_TRANSACTIONS = "/saved-transactions";
